// Residual-limb daily-log constants — shared between the modal and the card.
// IronLimb Pillar Session B.

export const SKIN_STATUS_OPTIONS = [
  { id: 'none', label: 'All clear', tone: 'green' },
  { id: 'minor', label: 'Minor irritation', tone: 'amber' },
  { id: 'concern', label: 'Concern', tone: 'orange' },
  { id: 'serious', label: 'Serious — see a clinician', tone: 'red' },
];

export const SOCKET_FIT_OPTIONS = [
  { id: 'perfect', label: 'Perfect' },
  { id: 'loose', label: 'Loose' },
  { id: 'tight', label: 'Tight' },
  { id: 'pain-point', label: 'Pain point' },
];

export const PHANTOM_SENSATION_TAGS = [
  'burning',
  'throbbing',
  'electric',
  'itching',
  'cramping',
  'pins & needles',
  'stabbing',
  'aching',
];

// Heat-map tone for the 7-day strip on the card.
export const skinStatusTone = (status) => {
  switch (status) {
    case 'none': return 'bg-emerald-500/40';
    case 'minor': return 'bg-amber-500/50';
    case 'concern': return 'bg-orange-500/60';
    case 'serious': return 'bg-red-500/70';
    default: return 'bg-enf-surface-mid';
  }
};

// `YYYY-MM-DD` for "today" in the user's local timezone.
export const todayLocalISO = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

// Build an array of the last N local-date strings, newest first.
export const lastNDays = (n) => {
  const out = [];
  const base = new Date();
  for (let i = 0; i < n; i += 1) {
    const d = new Date(base);
    d.setDate(base.getDate() - i);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    out.push(`${yyyy}-${mm}-${dd}`);
  }
  return out;
};
